import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CloneIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "16"}
      viewBox="0 0 14 16"
    >
      <g id="Clone" transform="translate(-26.373 -51.75)">
        <path
          id="Path_10204"
          data-name="Path 10204"
          d="M13.561-10.189l-1.621-1.621a1.723,1.723,0,0,0-1.061-.439H5.5A1.5,1.5,0,0,0,4-10.75v1.5H1.5A1.5,1.5,0,0,0,0-7.75v10a1.5,1.5,0,0,0,1.5,1.5h7A1.5,1.5,0,0,0,10,2.25V.75h2.5A1.5,1.5,0,0,0,14-.75V-9.129A1.723,1.723,0,0,0,13.561-10.189ZM8.313,2.25H1.688A.188.188,0,0,1,1.5,2.063V-7.562a.188.188,0,0,1,.187-.187H4v7A1.5,1.5,0,0,0,5.5.75h3V2.063A.188.188,0,0,1,8.313,2.25Zm4-3H5.688A.188.188,0,0,1,5.5-.937v-9.625a.188.188,0,0,1,.188-.187H9V-8a.75.75,0,0,0,.75.75H12.5V-.937A.188.188,0,0,1,12.313-.75Zm.188-8h-2v-2h.3a.188.188,0,0,1,.133.055l1.512,1.512a.215.215,0,0,1,.055.133h0Z"
          transform="translate(26.373 64)"
          fill={color || "#bbb"}
        />
      </g>
    </svg>
  );
}
